// Client-side configuration
// This file imports shared configuration and adds client-specific overrides
import { sharedConfig } from './shared';

export const appConfig = {
  // Import shared configuration
  ...sharedConfig,

  // Contact Information
  // Note: You can customize these fields with your actual information
  // For example: name: 'Elliot Koss' or keep it generic like 'Support Team'
  // This is what users will see in contact forms, invite pages, etc.
  contact: {
    primary: {
      name: 'Support Team', // Customize: 'Your Name' or 'Support Team' or 'Elliot Koss'
      email: 'support@recapvid.com' // Customize: 'yourname@company.com' or 'support@company.com'
    },
    // Alternative contact methods
    support: {
      email: 'help@recapvid.com',
      name: 'Help Desk'
    }
  },

  // Redirect domain for invite links and other redirects
  redirectDomain: process.env.REACT_APP_REDIRECT_DOMAIN || 'http://localhost:3000',

  // Feature flags
  features: {
    useVideoHero: process.env.REACT_APP_USE_VIDEO_HERO === 'true' || true, // Default to true, can be overridden with env var
  },

  // Pricing Configuration
  pricing: {
    plans: {
      standard: {
        name: 'RecapVid',
        monthlyPrice: 10,
        features: {
          weeklyRecaps: '∞',
          leagueSupport: 'Unlimited',
          videoQuality: 'HD',
          mobileAccess: true,
          socialSharing: true,
        },
        description: 'Weekly fantasy football recap videos',
        featuresList: [
          'Weekly 2-minute recap videos',
          'NFL fantasy football coverage',
          'HD video quality',
          'Mobile and desktop access',
          'Easy social media sharing',
        ]
      }
    },
    pricingText: {
      goal: 'Get your weekly fantasy football recap video delivered every Monday.',
      noCreditCard: '(no credit card required)',
      monthly: 'month',
      select: 'Subscribe',
      choose: 'Choose'
    },
    // Fantasy football specific feature descriptions
    featureLabels: {
      weeklyRecaps: 'Weekly Recap Videos',
      leagueSupport: 'League Support',
      videoQuality: 'Video Quality',
      mobileAccess: 'Mobile Access',
      socialSharing: 'Social Sharing'
    }
  }
};

export default appConfig;
